import React from 'react';

import { Stack, Typography } from '@mui/material';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';

import { customerDataFormatter, orderLinkFormatter, orderStatusFormatter, orderTotalFormatter } from '../formatters';

// Merchandise-specific formatters
function merchandiseInformationFormatter({ row }: GridRenderCellParams<App.Order>) {
  if (!row.merchandise_items || row.merchandise_items.length === 0) {
    return <Typography>No merchandise items</Typography>;
  }

  // Filter out shipping items - only show actual merchandise products
  const productItems = row.merchandise_items.filter((item) => item.type !== 'merchandise_shipping');

  return (
    <Stack direction="column" spacing={0.5}>
      <Typography variant="body2" fontWeight="bold">
        {productItems.length} item{productItems.length > 1 ? 's' : ''}
      </Typography>
      {productItems.slice(0, 2).map((item, index) => (
        <Typography key={index} variant="body2" sx={{ fontSize: '0.75rem' }} noWrap>
          {item.display_cache?.name || 'Merchandise Item'}
        </Typography>
      ))}
      {productItems.length > 2 && (
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
          +{productItems.length - 2} more items
        </Typography>
      )}
    </Stack>
  );
}

export const columns: Array<GridColDef> = [
  {
    field: 'fk_customer_id',
    headerName: 'Customer',
    sortable: false,
    flex: 1,
    renderCell: customerDataFormatter,
    display: 'flex',
  },
  {
    field: 'status',
    headerName: 'Order Status',
    sortable: false,
    flex: 1,
    renderCell: orderStatusFormatter,
    display: 'flex',
  },
  {
    field: 'merchandise_information',
    headerName: 'Shop Items',
    sortable: false,
    flex: 2,
    renderCell: merchandiseInformationFormatter,
    display: 'flex',
  },
  {
    field: 'currency_code',
    headerName: 'Currency',
    sortable: false,
    display: 'flex',
  },
  {
    field: 'total',
    headerName: 'Order Total',
    sortable: false,
    width: 120,
    renderCell: orderTotalFormatter,
    display: 'flex',
  },
  {
    field: 'id_orders',
    headerName: 'View Order',
    sortable: false,
    width: 120,
    renderCell: orderLinkFormatter,
    display: 'flex',
  },
];
